module.exports = __webpack_public_path__ + "03_bob_yellow.f521852f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_bob_yellow.png
// module id = UWVb
// module chunks = 0